import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import axiosService from '../../utils/axios';
import authSlice from '../../store/slices/auth';
import { getProfileFromUser } from '@/api/profile';

const ProfileLoader = () => {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.auth.user);
    const profile = useSelector((state: RootState) => state.auth.profile);

    // Load profile and ensure profile photo is available
    useEffect(() => {
        const loadProfile = async () => {
            if (user?._id) {
                try {
                    // Even if we have a profile in Redux, fetch to ensure we have the latest data
                    const profileData = await getProfileFromUser(user._id);

                    if (profileData) {
                        // Update Redux store with fresh profile data
                        dispatch(authSlice.actions.setProfile(profileData));

                        // Cache the profile photo with timestamp for Header component
                        if (profileData.profilePhoto) {
                            localStorage.setItem(
                                `userProfilePhoto_${user._id}`,
                                JSON.stringify({
                                    photoUrl: profileData.profilePhoto,
                                    timestamp: Date.now()
                                })
                            );
                        }
                    }
                } catch (error) {
                    console.error('Error loading profile:', error);

                    // If we have no profile yet, try to get it from basic endpoint
                    if (!profile) {
                        try {
                            const { data } = await axiosService.get(`/profile/userId/${user._id}`);
                            if (data) {
                                dispatch(authSlice.actions.setProfile(data));
                            }
                        } catch (secondError) {
                            console.error('Error loading profile with fallback method:', secondError);
                        }
                    }
                }
            }
        };

        loadProfile();
    }, [user, dispatch]);

    return null; // This component doesn't render anything
};

export default ProfileLoader;
